import ModalAction from '@/enum/ModalAction';

export default {
	methods: {
		clear() {},
		async show() {
			return await this.$refs['modal'].show();
		},
		cancel() {
			this.hide(ModalAction.CANCEL);
		},
		hide(action) {
			this.clear();
			this.$refs['modal'].hide(action);

			this.$emit('hide');
		},
		save(payload) {
			this.$emit('emit:data', payload);
			this.hide(ModalAction.SAVE);
		},
	},
};
